import { MAP_LINE_COLOR, MAP_LINE_COLOR_UNKNOWN } from '@/lib/constants';

import mapTheme from './theme';

const defaultMapOptions = {
  center: {
    lat: 34.0522,
    lng: -118.2437,
  },
  zoom: 10,
  options: {
    maxZoom: 12,
    styles: mapTheme,
    scrollwheel: false,
    navigationControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    overviewMapControl: false,
    fullScreenControl: false,
    controlSize: 20,
    scaleControl: true,
    zoomControlOptions: {
      position: 3,
    },
  },
};

const solidPathOptions = {
  strokeColor: MAP_LINE_COLOR,
  strokeOpacity: 0.9,
  strokeWeight: 2,
  visible: true,
  zIndex: 3,
  geodesic: true,
};

const outlinePathOptions = {
  strokeColor: MAP_LINE_COLOR,
  strokeOpacity: 0.2,
  strokeWeight: 8,
  visible: true,
  zIndex: 2,
  geodesic: true,
};

const dashSymbol = {
  path: 'M 0,-1 0,1',
  strokeOpacity: 1,
  scale: 3,
  strokeWeight: 3,
  strokeColor: MAP_LINE_COLOR, // @TODO Fix: this will override StrokeColor on path
};

const dashedPathOptions = {
  strokeOpacity: 0,
  visible: true,
  zIndex: 3,
  geodesic: true,
  icons: [
    {
      icon: dashSymbol,
      offset: '0',
      repeat: '16px',
    },
  ],
};

const dashLightSymbol = {
  ...dashSymbol,
  strokeWeight: 1.5,
  strokeOpacity: 0.65,
  strokeColor: MAP_LINE_COLOR_UNKNOWN,
};

const dashedLightPathOptions = {
  ...dashedPathOptions,
  icons: [
    {
      icon: dashLightSymbol,
      offset: '0',
      repeat: '12px',
    },
  ],
};

export { dashedLightPathOptions, dashedPathOptions, defaultMapOptions, outlinePathOptions, solidPathOptions };
